'use client';
import React from 'react';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { ModalProvider } from './modal-provider';
import CustomWagmiProvider from './wagmi-provider';
import { LandPurchaseProvider } from './land-purchase-context';
import { UserInfoProvider } from './userinfo-context';
import { TransactionProvider } from './transactions-context';
import { MapProvider } from './map-context';

type ProviderType = {
  children: React.ReactNode;
};

const Providers = ({ children }: ProviderType) => {


  return (
    <CustomWagmiProvider>
      <TransactionProvider>
        <LandPurchaseProvider>
          <UserInfoProvider>
            <MapProvider>
              <ModalProvider>{children}</ModalProvider>
            </MapProvider>
          </UserInfoProvider>
        </LandPurchaseProvider>
      </TransactionProvider>
    </CustomWagmiProvider>
  );
};

export default Providers;
